exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".phonebook-list .phonebook-item {\n  display: flex;\n  height: 10rem;\n  align-items: center;\n  padding: 0 4rem;\n  border-bottom: 1px solid #E6E6E6;\n}\n\n.phonebook-list .phonebook-item>h2 {\n  margin-left: 3rem;\n}\n\n", ""]);

// exports
